import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Site } from '../../classes/site';

@Component({
	selector: 'app-site-advert-author',
	templateUrl: './site-advert-author.component.html',
	styleUrls: ['./site-advert-author.component.scss'],
})
export class SiteAdvertAuthorComponent {
	@Input() site: Site;

	@Output() stepChange = new EventEmitter();

	constructor() {
	}
}
